import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import type { FormikProps } from 'formik';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { importModalAtom } from '@/atoms/import';
import { FormTip } from '@/components/FormTip/FormTip';
import { UploadField } from '@/components/UploadField/UploadField';
import { UPLOAD_MAX_FILESIZE } from '@/constants';
import { ImportInfo } from './ImportScript.styles';
import type { TImportValues } from './ImportScriptForm';
import { ImportScriptRepeat } from './ImportScriptRepeat';
import { ImportScriptRulesButton } from './ImportScriptRulesButton';

interface IImportScriptUpload {
    formik: FormikProps<TImportValues> | null;
}

export const ImportScriptUpload = ({ formik }: IImportScriptUpload) => {
    const { t } = useTranslation();
    const { statistics: checkResult, ready, checked } = useAtomValue(importModalAtom);

    const critical = checkResult && Boolean(checkResult.exceptions.length);

    return (
        formik && (
            <>
                {checked && (
                    <ImportInfo>
                        <FormTip
                            icon={<ErrorOutlineIcon />}
                            children={critical ? t('import.crit-info') : t('import.error-info')}
                            crit={Boolean(critical)}
                        />
                        <ImportScriptRulesButton />
                    </ImportInfo>
                )}
                {ready ? (
                    <ImportScriptRepeat />
                ) : (
                    <UploadField
                        value={formik.values.file?.name ?? null}
                        accept=".docx"
                        onChange={f => formik.setFieldValue('file', f)}
                        uploadFormat={['DOCX']}
                        uploadMaxSize={UPLOAD_MAX_FILESIZE}
                        sx={{ my: '12px' }}
                    />
                )}
            </>
        )
    );
};
